import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { useCurrency } from "../contexts/CurrencyContext";

export default function CurrencySelector() {
  const { currency, setCurrency, currencies } = useCurrency();

  return (
    <Select
      value={currency.code}
      onValueChange={(code) => setCurrency(currencies.find((c) => c.code === code))}
    >
      <SelectTrigger
        data-testid="currency-selector"
        className="!h-9 w-auto gap-1.5 rounded-full border-[#E6E9F1] bg-white px-4 text-sm font-medium text-[#0B1533] shadow-[0_2px_10px_rgba(11,21,51,0.05)] focus:ring-[#FF6B00]"
      >
        <SelectValue>
          {currency.symbol} {currency.code}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {currencies.map((c) => (
          <SelectItem key={c.code} value={c.code} data-testid="currency-option">
            {c.symbol} {c.code} - {c.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
